import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ConfigService } from "src/app/services/config.service";
import { Permission, GroupedPermission } from "../models/permission.model";
import { AuthenticationService } from "src/app/services/authentication.service";

@Injectable()
export class PermissionService {
    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService,
        private authService: AuthenticationService,
    ) {
        this.getPermissions().subscribe((items) => {
            this.setPermissions(items);
        });
    }

    permissionsList: Permission[] = [];
    permissionsLoaded = false;

    permissionGroups: GroupedPermission[] = [];

    getPermissionsForGroup(group: string): string[] {
        return this.permissionsList
            .filter((perm) => {
                return perm.group === group;
            })
            .map((p) => p.permission);
    }

    toGroupedPermissions(permissions: Permission[]): GroupedPermission[] {
        return permissions
            .map((perm) => perm.group)
            .filter((perm, index, permissionsArray) => {
                return permissionsArray.indexOf(perm) === index;
            })
            .map((group) => {
                return {
                    group: group,
                    permissions: this.getPermissionsForGroup(group),
                };
            });
    }

    getPermissions() {
        return this.httpClient.get<Permission[]>(
            this.configService.apiBaseUrl.concat("Permission/Permissions"),
        );
    }

    setPermissions(permissions: Permission[]) {
        this.permissionsList.length = 0;
        this.permissionsList.push(...permissions);
        this.permissionGroups.length = 0;
        this.permissionGroups.push(
            ...this.toGroupedPermissions(this.permissionsList),
        );
        this.permissionsLoaded = true;
    }
}
